import { render, staticRenderFns } from "./index.vue?vue&type=template&id=878c5618&scoped=true&lang=pug"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./style.scss?vue&type=style&index=0&id=878c5618&prod&scoped=true&lang=scss&external"
import style1 from "./index.vue?vue&type=style&index=1&id=878c5618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878c5618",
  null
  
)

export default component.exports